function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0.431712 12.9379C-0.784919 15.8892 0.669921 19.2483 3.68119 20.4407L8.087 9.75318C5.07573 8.56079 1.64834 9.98664 0.431712 12.9379Z",
  fill: "url(#paint0_linear_7131_133926)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M7.75662 14.9504C6.36618 18.3233 8.02886 22.1622 11.4703 23.525C14.9117 24.8877 18.8288 23.2582 20.2192 19.8853L7.75662 14.9504Z",
  fill: "url(#paint1_linear_7131_133926)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M19.3535 0.00634766C23.6553 1.70976 25.7337 6.50848 23.9956 10.7246C22.2576 14.9407 17.3613 16.9776 13.0595 15.2742L19.3535 0.00634766Z",
  fill: "url(#paint2_linear_7131_133926)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M4.04293 6.37581C5.08576 3.84615 8.02352 2.62399 10.6046 3.64604C13.1857 4.66809 14.4327 7.54732 13.3899 10.077L4.04293 6.37581Z",
  fill: "url(#paint3_linear_7131_133926)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M30.5156 21.2647V2.40625H38.1095C40.7418 2.40625 42.9343 3.3249 44.6693 5.16055C46.4193 6.97558 47.2927 9.20562 47.2927 11.8355C47.2927 14.4658 46.4191 16.7044 44.6693 18.5367C42.934 20.3552 40.7414 21.2647 38.1095 21.2647H30.5156ZM53.5254 18.059C54.3571 18.6711 55.3811 18.983 56.6118 18.983C58.3214 18.983 59.529 18.3741 60.2859 17.1767L60.4076 16.9841L62.824 18.3217L62.6858 18.5304C61.326 20.5834 59.2703 21.6063 56.558 21.6063C54.3668 21.6063 52.5613 20.9397 51.1636 19.5946L51.1613 19.5924C49.7842 18.2312 49.0987 16.5152 49.0987 14.4625C49.0987 12.4277 49.7749 10.7211 51.1332 9.36008C52.4945 7.99605 54.2562 7.31884 56.3964 7.31884C58.4356 7.31884 60.1095 8.02717 61.3969 9.4459C62.6954 10.8396 63.3438 12.5251 63.3438 14.4888C63.3438 14.8339 63.3159 15.1871 63.2604 15.5482L63.2296 15.7479H52.0356C52.2862 16.7362 52.7846 17.5017 53.5254 18.059ZM53.4274 10.9373C52.7147 11.5266 52.2465 12.3041 52.0275 13.2822H60.4464C60.2294 12.2179 59.7666 11.4179 59.0719 10.8608C58.3082 10.2484 57.4199 9.94214 56.3964 9.94214C55.1882 9.94214 54.2055 10.2774 53.4296 10.9354L53.4274 10.9373ZM85.8928 21.2647H83.0684V12.9389C83.0684 11.9629 82.8103 11.2394 82.3254 10.7349C81.8387 10.2286 81.1876 9.96841 80.346 9.96841C79.4013 9.96841 78.6612 10.2779 78.1011 10.8884C77.5647 11.4751 77.2734 12.4056 77.2734 13.727V21.2647H74.449V12.9389C74.449 11.961 74.1988 11.2363 73.7302 10.732L73.7288 10.7305L73.7274 10.729C73.2774 10.2274 72.6566 9.96841 71.8343 9.96841C70.9094 9.96841 70.1468 10.2771 69.5297 10.8947C68.9421 11.5004 68.6271 12.4299 68.6271 13.727V21.2647H65.8027V7.66036H68.6271V8.9393C69.5617 7.86031 70.8259 7.31884 72.4 7.31884C73.341 7.31884 74.1676 7.51219 74.8705 7.90859C75.4701 8.24671 75.9697 8.72697 76.3711 9.34254C77.3488 7.99394 78.7642 7.31884 80.5884 7.31884C82.1545 7.31884 83.4414 7.82139 84.4257 8.83644C85.4119 9.83574 85.8928 11.1864 85.8928 12.86V21.2647ZM92.5796 18.059C93.4113 18.6711 94.4354 18.983 95.6661 18.983C97.3756 18.983 98.5832 18.3741 99.3401 17.1767L99.4618 16.9841L101.878 18.3217L101.74 18.5304C100.38 20.5834 98.3246 21.6063 95.6122 21.6063C93.421 21.6063 91.6156 20.9397 90.2178 19.5946L90.2155 19.5924C88.8384 18.2312 88.153 16.5152 88.153 14.4625C88.153 12.4277 88.8292 10.7211 90.1874 9.36008C91.5487 7.99605 93.3104 7.31884 95.4506 7.31884C97.4899 7.31884 99.1638 8.0272 100.451 9.44598C101.75 10.8397 102.398 12.5251 102.398 14.4888C102.398 14.8339 102.37 15.1871 102.315 15.5482L102.284 15.7479H91.0899C91.3405 16.7362 91.8389 17.5017 92.5796 18.059ZM92.4839 10.9354L92.4816 10.9373C91.7689 11.5266 91.3008 12.3041 91.0818 13.2822H99.5006C99.2837 12.2179 98.8209 11.4179 98.1261 10.8608C97.3625 10.2484 96.4741 9.94214 95.4506 9.94214C94.2425 9.94214 93.2597 10.2774 92.4839 10.9354ZM116.633 21.2647H113.288L109.637 16.4582L105.96 21.2647H102.613L107.964 14.2784L102.91 7.66036H106.284L109.638 12.0721L112.991 7.66036H116.338L111.311 14.2527L116.633 21.2647ZM38.1095 18.4838C39.9674 18.4838 41.4725 17.852 42.6451 16.5905C43.8217 15.3249 44.4144 13.7455 44.4144 11.8355C44.4144 9.92551 43.8217 8.34612 42.6451 7.08045C41.4725 5.81903 39.9674 5.18717 38.1095 5.18717H33.5016V18.4838H38.1095Z",
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_7131_133926",
  x1: 24.6096,
  y1: 12.0064,
  x2: 0.00195345,
  y2: 12.0064,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#482BFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#007AFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_7131_133926",
  x1: 24.6096,
  y1: 12.0064,
  x2: 0.00195345,
  y2: 12.0064,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#482BFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#007AFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_7131_133926",
  x1: 24.6096,
  y1: 12.0064,
  x2: 0.00195345,
  y2: 12.0064,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#482BFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#007AFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear_7131_133926",
  x1: 24.6096,
  y1: 12.0064,
  x2: 0.00195345,
  y2: 12.0064,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#482BFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#007AFF"
})));

function SvgDemex(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 25,
    viewBox: "0 0 117 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDemex);
export default __webpack_public_path__ + "static/media/Demex.a04fc5838798145a57757ac7bdfd01a9.svg";
export { ForwardRef as ReactComponent };